import { render } from "./SavedConfig.vue?vue&type=template&id=d009f9de"
import script from "./SavedConfig.vue?vue&type=script&lang=js"
export * from "./SavedConfig.vue?vue&type=script&lang=js"

import "./SavedConfig.vue?vue&type=style&index=0&id=d009f9de&lang=scss"

import exportComponent from "C:\\Devprojects\\cedaci-compass\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__